import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { Checkbox } from "@/shared/components/check-box/check-box";
import React, { useEffect, useState } from "react";
import { AccountsInfo, useSelectAccounts } from "@/features/accounts/shared/hooks/use-select-accounts";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { useInputValidation } from "@/shared/hooks/use-input-validation";


interface Props {
  accounts: AccountsInfo[],
  onTapCompleteModal: (registAccounts: AccountsInfo[], mitsubishiUfjCorp: string) => void;
  onTapCloseModal: () => void;
}

// 登録口座選択モーダル
export const SelectAccountsModal= ({ accounts, onTapCompleteModal, onTapCloseModal }: Props) => {
  const [list, setList] = useState<AccountsInfo[]>(
    accounts.filter(account => account.selectedStatus === 0)
  );
  const {
    isActiveRegisterButton,
    setIsActiveRegisterButton,
    onClickRegister,
    cancelRegistration,
  } = useSelectAccounts({onTapCompleteModal});
  const { validate } = useInputValidation("deleteOver4Bytes");
  const companyName = localStorage.getItem("companyName") || "";
  const serviceName = localStorage.getItem("serviceName") || "";
  const branchName = localStorage.getItem("branchName") || "";
  const institutionName = companyName + (branchName !== "" ? " " + branchName : "");
  const serviceType = serviceName.startsWith("[法人]") ? " [法人]" : "";

  useEffect(() => {
    const updateList = () => {
      const updlist = list.map((item) => ({
        ...item,
        userInputName: validate(`${institutionName} ${item.accountKindName}${serviceType}` +
                        `${(item.accountNo !== "" && item.accountNo !== undefined) ? " 口座No." + item.accountNo : ""}`),
      }));
      setList(updlist);
      };
    updateList();
  }, []);

  // チェックボックスのON/OFF
  const onClickCheck = (index: number) => {
    const updated = [...list];
    updated[index].selectedStatus = updated[index].selectedStatus === 1 ? 0 : 1;
    setList(updated);
  };

  const onChangeRegisterButtonState = (index: number, value: string) => {
    const updated = [...list];
    updated[index].userInputName = value;
    setList(updated);
  }

  useEffect(() => {
    const updated = [...list];
    // 作成ボタンの活性/非活性制御
    let hasChecked = updated.every((item) => 
      (item.selectedStatus === 1 && item.userInputName.trim() !== "")
      || (item.selectedStatus === 0)
    );
    if (updated.every((item) => item.selectedStatus === 0)) {
      hasChecked = false;
    }
    setIsActiveRegisterButton(hasChecked);
  }, [list]);

  // 作成ボタンに付与するID
  const createAccountsButton = "create_accounts_button";

  // 登録時にユーザー入力の値をトリム（前後の空白を削除）してから処理する
  const handleRegister = () => {
    const trimmedList = list.map((item) => ({
      ...item,
      userInputName: item.userInputName?.slice(0, 50).trim() ?? "",
    }));

    onClickRegister(trimmedList);
  };

  const passbookType = list[0]?.passbookType;
  let institutionType = "";
  if (passbookType === "01") {
    institutionType = "bank";
  } else if (passbookType === "03" || passbookType === "19659" || passbookType === "19660") {
    institutionType = "card";
  } else if (passbookType === "10") {
    institutionType = "ev";
  } else if (passbookType === "20") {
    institutionType = "other";
  }


  return (
    <BasePageModal
      title="口座の選択"
      handleClose={() => {
        cancelRegistration(list);
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="Web明細帳を作成"
          onClick={handleRegister}
          id={createAccountsButton}
          loadingNegative={true}
          isActive={isActiveRegisterButton}
        />
      }
      className={`md-add-bank ${institutionType}`}
      disableOverlayClose={true}
    >
      <h2>連携させる口座をすべて選択してください</h2>
      <ul>
        {list.map((item, index) => (
          <li key={`${item.mlinkAccountId}-${item.mlinkId}`}>
            <Checkbox
              label={`${institutionName} ${item.accountKindName}${serviceType}
                      ${(item.accountNo !== "" && item.accountNo !== undefined) ? " 口座No." + item.accountNo : ""}`}
              id={`account-${index}`}
              checked={item.selectedStatus === 1}
              handleChange={() => {
                onClickCheck(index)
              }}
            />
            <SimpleForm
              placeholder="Web明細帳名を設定（必須）"
              initialValue={`${institutionName} ${item.accountKindName}${serviceType} `+
                            `${(item.accountNo !== "" && item.accountNo !== undefined) ? " 口座No." + item.accountNo : ""}`}
              onChange={(value) => {
                onChangeRegisterButtonState(index, value)
              }}
            />
          </li>
        ))}
      </ul>
    </BasePageModal>
  );
};
